<template>
	<div class="publish_item position-relative">
		<div style="width: 100%;height: 100%;position: absolute;background-color: rgba(0,0,0,0.3);z-index: 1000;" v-if="rgbaState == true" @click="togleState">
			<div style="width: 396px;height: 790px;box-sizing: border-box;position: absolute;background-color: white;left: 50%;margin-left: -198px;bottom: 240px;border-radius: 14px;border: 8px solid #0C275E;z-index: 10000;">
				<img style="width: 370px;height: 64px;margin-left: 5px;margin-right: 10px; position: absolute;top: 0;left: 0;right:0;z-index: 9999;" src="../../assets/distributors/toubu.png" />
				<div style="width:100%;height:  650px;overflow-y: scroll; position: absolute;top: 64px;left: 0;right: 0;">
					<el-carousel indicator-position="none" :interval="3000" :loop="true" height="375px">
						<el-carousel-item v-for="(item,index) in goodsmsg.goods_gallery" :key="index">
							<img :src="item.img" v-if="item.img != ''" style="width: 100%;;height: 23.4375rem;" alt="">
						</el-carousel-item>
					</el-carousel>
					<div style="padding-left: 15px;padding-right: 15px;margin-top: 10px;">
						<div class="text-suojin" style="width: 100%;color: #000000;font-size: 17px;font-weight: 700;">{{goodsmsg.goods_name}}</div>
						<div style="color: #FF3A3A;font-size: 20px;font-weight: 700;">{{'¥' + minNumber + ' ~' + maxNumber}}</div>
						<img src="../../assets/distributors/zhanshiyanghsi.png" style="width: 100%;height: 330px;" alt="">
					</div>
					<div>
						<div style="height: 50px;" class="d-flex a-center j-center">
							<div class="" style="width: 20px;height: 2px;background-color: #000000;"></div>
							<div class="" style="color: #000000;font-size: 30upx;font-weight: 700;padding-left: 10px;padding-right: 10px;">产品详情</div>
							<div class="" style="width: 20px;height: 2px;background-color: #000000;"></div>
						</div>
						<div v-for="(item,index) in goodsmsg.desc_mobile" :key="index">
							<img :src="item.img" style="width: 100%;height: 100%;" alt="">
						</div>
					</div>
				</div>
				<img style="width: 380px;height: 60px; position: absolute;bottom: 0;left: 0;right:0;z-index: 9999;" src="../../assets/distributors/dibu.png" />
			</div>
		</div>
		<!-- <div class="sale_data">
			<span class="title" style="font-size: 1rem;font-weight: bold;position: relative">销售数据</span>
			<div class="selected">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;margin-top: 1.75rem;">选择产品类目<span style="color: red;">(必填*)</span>	:<span
						 style="color: #1E69FF;font-size: 0.75rem;font-weight: bold;margin-left: 0.88rem;">{{goodsmsg.cat_str}}</span></span>
				</div>
			</div>
			<elCascaderPanel ref="item_classify" @change="handleCascaderChange" class="select" :options="options"></elCascaderPanel>
		</div> -->
		<div class="base_info">
			<span class="title" style="font-size: 1rem;font-weight: bold;position: relative">基本信息</span>
			<div class="upload_main_pic" style="margin-top: 1.56rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">上传产品主图<span style="color: red;">(产品主图必填*建议750*750)</span></span>
				</div>
				<div class="d-flex a-center flex-wrap">
					<el-upload style="width: 7.5rem;height: 7.5rem;margin-right: 10px;margin-bottom: 1rem;position: relative;" class="avatar-uploader" 
					action="upload"
					:http-request="handleUploadFile"
					:show-file-list="false" 
					:on-progress="uploadPicProcess" 
					:on-remove="handleRemove"
					:on-change="getGoodsimg"
					:before-upload="beforeAvatarUpload">
						<div class="position-absolute d-flex a-center j-center" style="top: 0;left: 0;right: 0;width: 100%;height: 20px;background-color: rgba(0,0,0,0.3);color: white;font-size: 14px;">产品主图</div>
						<img style="width: 100%;height: 100%;border-radius: 6px;" :src="goodsImgbase64" v-if="goodsImgbase64 != ''" alt="">
						<div v-else class="h-100 d-flex flex-column j-center a-center">
							<img src="../../assets/itemStore/tianjia@2x.png" alt="" style="width: 2.31rem;height: 2.32rem;">
							<span style="line-height: 1;color: #1E69FF;font-size: 0.75rem;">添加上传图片</span>
						</div>
						<!-- <el-progress v-if="imgflag" type="circle" v-bind:percentage="percenTage"></el-progress> -->
					</el-upload>
				</div>
			</div>
			<div class="item_title" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品标题<span style="color: red;">(必填*)</span></span>
				</div>
				<input type="text" placeholder="请输入产品标题最多30个字" maxlength="30" v-model="goodsmsg.goods_name" style="width: 48.44rem;height: 1.88rem;padding: 0 1.06rem;box-sizing: border-box; border:1px solid #1E69FF;border-radius: 4px; outline-color: #1E69FF;margin: 0 auto;display:block;">
			</div>
			<div class="item_video" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品视频（非必填）</span>
				</div>
				<div class="wrap d-flex j-start a-center" style="height: 7.5rem;">
					<el-upload style="height: 7.5rem;min-width: 7.5rem;" class="avatar-uploader" 
					action="https://www.spmall.com/seller/enterprise_publicity_manage_api.php"
					:show-file-list="false" 
					name="video"
					:data="{'act':'upload_video','token':token,'user_id':user_id}"
					:on-success="videoSuccess"
					 accept='.mp4,.avi,.wmv,.swf,.flv'>
						<div  v-if="videoBase64 == ''" class="d-flex flex-column j-center a-center" style="height: 100%;">
							<div class="a-center j-center d-flex flex-column">
								<img src="../../assets/itemStore/shiping@2x.png" alt="" style="width: 2.75rem;height: 2.75rem;">
								<span style="color: #1E69FF;font-size: 0.75rem;line-height: 1;">选择视频</span>
							</div>
						</div>
						<div v-else>
							<video style="width: 13rem;height:8rem" :src="videoBase64" controls="true" :autoplay="true" ></video>
						</div>
					</el-upload>
					<div class="flex-1 d-flex flex-column j-sb a-start" style="height: 7.5rem;width: 7.5rem;padding-left: 1.19rem;font-size: 0.75rem;color: #888888;">
						<span style="line-height: 1;">1.尺寸：上传视频1：1或16：9为宜</span>
						<span style="line-height: 1;">2.时长：视频时长不超过60S，大小不超过50MB</span>
						<span style="line-height: 1;">3.内容：尽量突出产品的卖点</span>
					</div>
				</div>
			</div>
			<div class="item_detail" style="margin-top: 2.75rem;">
				<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品详情<span style="color: red;">(必填*上图片不建议超过10MB)</span></span>
				</div>
				<div class="d-flex">
					<div style="width: 365px;height: 660px;border: 1px solid #979797;border-radius: 6px;overflow: hidden;">
						<div style="width: 100%;height: 48px;background: #f5f5f5;" class="d-flex">
							<div @click="txtShow=true" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
								<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wenzi.png" />
								<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">文字</div>
							</div>
							<el-upload style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center"
							  :action="$apiurl + 'seller/enterprise_publicity_manage_api.php'"
							  :data="{'act':'upload_photo_introduction','token':token,'user_id':user_id}"
							  :show-file-list="false"
							  :on-success="getLiveDylist">
							  <div style="cursor: pointer;width: 100%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
								<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/tupian@2x.png" />
								<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">图片</div>
							  </div>
							</el-upload>
							<div @click="setcenter()" style="cursor: pointer;width: 16.666%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
								<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/juzhong.png" />
								<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">居中</div>
							</div>
							<div @click="upFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
								<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/san.png" />
								<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">上移</div>
							</div>
							<div @click="dowFiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
								<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/itemStore/xiayi@2x.png" />
								<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">下移</div>
							</div>
							<div @click="delfiles()" style="cursor: pointer;width: 20%;flex-wrap: wrap;text-align: center;" class="d-flex j-center">
								<img style="width: 18px;height: 18px;margin-top: 8px;" src="../../assets/brand_fixtures/wu.png" />
								<div style="font-size: 10px;color: #666666;width: 100%;text-align: center;margin-bottom: 8px;transform: scale(0.9);">删除</div>
							</div>
						</div>
						<div class="txt-box d-flex" style="height: 612px;width: 100%;overflow-y: scroll;flex-wrap: wrap;">
							<div style="width: 100%;">
								<template v-for="(img,imgkey) in dyList">
									<img v-if="img.type == 2" style="width: 365px;box-sizing: border-box;display: block;"
									:style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
									@click="dyIndex = imgkey" :src="img.content" />
									<div @click="dyIndex = imgkey" :style="imgkey === dyIndex?'border: 1px dashed #1E69FF;':''"
									v-else style="padding: 3px 6px;font-size: 15px;color: #666;cursor: pointer;"
									:class="img.type == 3?'tct':'ntxt'">
										{{img.content}}
									</div>
								</template>
							</div>
						</div>
					</div>
				</div>
				<!-- <div style="width: 48.44rem;height: 53.5rem;margin: 0 auto;border: 2px solid #BBBBBB;border-radius: 4px;position: relative;">
					<div class="d-flex j-sb a-center" style="height: 3.13rem;width: 100%;background:linear-gradient(0deg, #F8F8F8 0%, #FFFFFF 100%);padding: 0 13.75rem;box-sizing: border-box; border-bottom: 2px solid #BBBBBB;font-size: 0.75rem;color: #666666;">
						<div class="d-flex flex-column j-center a-center">
							<el-upload 
							class="upload-demo" 
							list-type="picture" 
							multiple
							action="upload"
							:http-request="handleUploadFile"
							:show-file-list="false" 
							:on-progress="uploadPicProcess" 
							:on-remove="handleRemove"
							:on-change="getDescmobile"
							:before-upload="beforeAvatarUpload"
							>
								<div class="d-flex flex-column j-center a-center">
									<img src="../../assets/itemStore/tupian@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
									<span>图片</span>
								</div>
							</el-upload>
						</div>
						<div class="d-flex flex-column j-center a-center" style="cursor: pointer;" @click="moveup">
							<img src="../../assets/itemStore/shangyi@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
							<span>上移</span>
						</div>
						<div class="d-flex flex-column j-center a-center" style="cursor: pointer;" @click="movedown">
							<img src="../../assets/itemStore/xiayi@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
							<span>下移</span>
						</div>
						<div class="d-flex flex-column j-center a-center" style="cursor: pointer;" @click="delDescimg">
							<img src="../../assets/itemStore/shangchu@2x.png" alt="" style="width: 1.4rem;height: 1.4rem;">
							<span>删除</span>
						</div>
					</div>
					<div style="width: 100%;height: 50.3rem;overflow-y: scroll;">
						<div v-for="(item,index) in goodsmsg.desc_mobile">
							<img style="width: 100%;" :src="item.img" alt="" @click="descimgCli(index)">
						</div>
					</div>
				</div> -->
			</div>
			<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;margin-top: 2.75rem;">
				<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">
					产品/服务其它相关视频动态(在已发布中选择)
					<span @click="videoShow=true" style="color: #1E69FF;margin-left: 120px;cursor: pointer;">
						+添加视频
					</span>
				</span>
			</div>
			<div>
				<div v-for="(item,index) in videoList" :key="index" class="d-flex" v-if="item.checked">
					<div style="width: 366px;height: 209px;border-radius: 4px;margin-bottom: 20px;position: relative;">
						  <video width="366" height="209" style="border-radius: 4px;" :src="item.act_desc[1].content" controls="true" :autoplay="false" ></video>
					</div>
					<div>
						<div @click="item.checked=false" class="d-flex a-center j-center" style="width: 60px;height: 20px;background: #FFFFFF;cursor: pointer;
						border: 1px solid #666666;border-radius: 2px;font-size: 12px;color: #666666;margin-left: 19px;">
							删除
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;margin-top: 2.75rem;">
				<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">
					产品/服务相关动态(在已发布中选择)
					<span @click="articleShow=true" style="color: #1E69FF;margin-left: 168px;cursor: pointer;">
						+添加动态
					</span>
				</span>
			</div>
			<div v-for="(item,index) in articleList" :key="index" v-if="item.checked" class="d-flex">
				<div class="d-flex a-center"
				style="width: 366px;height: 80px;background: #F6F6F6;border-radius: 4px;position: relative;padding: 0 16px;box-sizing: border-box;margin-bottom: 15px;">
					  <div>
						  <div style="font-size: 14px;font-weight: 600;">{{item.title}}</div>
						  <div class="thd2" style="font-size: 12px;color: #888888;margin-top: 14px;">{{getTxt(item.doc_content)}}</div>
					  </div>
				</div>
				<div>
					<div @click="item.checked=false" class="d-flex a-center j-center" style="width: 60px;height: 20px;background: #FFFFFF;cursor: pointer;
					border: 1px solid #666666;border-radius: 2px;font-size: 12px;color: #666666;margin-left: 19px;">
						删除
					</div>
				</div>
			</div>
			<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;margin-top: 2.75rem;">
				<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">
					产品资料
					<span @click="fileShow=true" style="color: #1E69FF;margin-left: 313px;cursor: pointer;">
						+添加资料
					</span>
				</span>
			</div>
			<div style="width: 420px;">
				<div v-for="(item,index) in fileList" :key="index" >
					<div v-if="item.checked">
						<div style="padding: 12px;box-sizing: border-box;position: relative;width: 100%;"
						class="d-flex a-center" >
							
							<div>
								<div class="text-center">
									<img style="width: 50px;height: 50px;" src="../../assets/itemStore/wendang.png" />
								</div>
								
							</div>
							<div style="font-size: 12px;color: #888888;margin-left: 10px;"
							class="thd2">
								{{item.name}}
							</div>
							<img  @click="item.checked=false" style="width: 16px;height: 16px;cursor: pointer;margin-left: auto;"
							 src="../../assets/itemStore/guanbi.png" />
						</div>
					</div>
					
					<div class="wd" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
						<div v-for="(val,key) in item.child" :key="key" v-if="val.checked" 
						style="width: 33%;padding: 12px;box-sizing: border-box;position: relative;"
						class="d-flex a-center j-center" >
							<img  @click="val.checked=false" style="width: 16px;height: 16px;position: absolute;right: 0px;top: 0px;cursor: pointer;"
							 src="../../assets/itemStore/guanbi.png" />
							<div>
								<div class="text-center">
									<img style="width: 40px;height: 50px;" src="../../assets/itemStore/wdnang.png" />
								</div>
								<div style="font-size: 12px;color: #888888;"
								class="thd2">
									{{val.real_name}}
								</div>
							</div>
						</div>
					</div>
					
				</div>
				
			</div>
			<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;margin-top: 2.75rem;">
				<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">
					<el-input placeholder="请输入自定义文字" size="small" style="width: 200px;" v-model="ac_title" ></el-input> 
					<span style="margin-left: 8px;">可自定义文字</span>
					<span @click="hzhbShow=true" style="color: #1E69FF;margin-left: 56px;cursor: pointer;">
						+添加应用客户
					</span>
				</span>
			</div>
			<div class="hzhb" style="width: 420px;display: flex;flex-wrap: wrap;justify-content: space-between;">
				<div style="width: 116px;height: 44px;border: 1px solid #BBBBBB;border-radius: 4px;
				position: relative;margin-bottom: 14px;"
				class="d-flex a-center j-center" v-for="(item,index) in myptlist" :key="index" v-if="item.checked">
					<img @click="item.checked=false" style="width: 16px;height: 16px;position: absolute;right: -8px;top: -8px;cursor: pointer;"
					 src="../../assets/itemStore/guanbi.png" />
					 <img style="height: 30px;" :src="item.logo_thumb" />
				</div>
			</div>
			<div class="d-flex j-start a-center" style="margin-bottom: 1.19rem;margin-top: 2.75rem;">
				<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">
					隐藏此产品/服务（非本公司成员不可见，转发可见）
				</span>
			</div>
			
			<div style="margin-top: 10px;">
				<div class="d-flex a-center">
					<div @click="hide_status=0" class="d-flex a-center" style="cursor: pointer;">
						<img v-if="hide_status==0" style="width: 18px;height: 18px;" src="../../assets/itemStore/xuanzhong.png"/>
						<img v-else style="width: 18px;height: 18px;" src="../../assets/itemStore/moren.png"/>
						<div style="font-size: 12px;margin-left: 8px;">所有人可见</div>
					</div>
					<div @click="hide_status=1" class="d-flex a-center" style="cursor: pointer;">
						<img v-if="hide_status==1" style="width: 18px;height: 18px;margin-left: 71px;" src="../../assets/itemStore/xuanzhong.png"/>
						<img v-else style="width: 18px;height: 18px;margin-left: 71px;" src="../../assets/itemStore/moren.png"/>
						<div style="font-size: 12px;margin-left: 8px;">对非本公司人员隐藏</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="sale_property" style="margin-top: 3.69rem;">
			<div class="unify_price" style="margin-top: 1.56rem;">
				<div style="margin-bottom: 1.19rem;">
					<span class="second_title position-relative" style="font-size: 0.75rem;font-weight: bold;">产品价格:</span>
					<input v-model="goodsPrice" type="text"  placeholder="设置统一价格" style="max-width: 10.3rem;height: 1.88rem;text-align: center;border-radius: 4px;border: 2px solid #BBBBBB;outline: none;margin-left: 1.5rem;">元
				</div>
			</div>
		</div> -->
		<div style="font-size: 10px;color: #888888;margin-top: 35px;" class="d-flex a-center j-center">
			<img style="width: 12px;height: 12px;" src="../../assets/itemStore/jinggao@2x.png" />
			<div style="margin-left: 5px;">请勿使用“最”“独家”“首个”“纯天然”等字眼，请仔细阅读</div>
			<div @click="$router.push('ad_agreement')" style="color: #1E69FF;cursor: pointer;">《广告法》</div>
		</div>
		<div class="buttons d-flex a-center" style="justify-content: space-around;">
			<!-- <div class="button">保存草稿</div> -->
			<div class="button" style="background: #FF9D1F;color: #FFFFFF;border-color: #FF9D1F;" @click="togRgbaState">预览</div>
			<div class="button" style="background: #226CFF;color: #FFFFFF;border-color: #226CFF;" @click="publishGoods">发布</div>
		</div>
		<el-dialog
		  title="文本信息"
		  :visible.sync="txtShow"
		  width="30%"
		  top="30vh">
		  <el-input
		    type="textarea"
		    :autosize="{ minRows: 2, maxRows: 4}"
		    placeholder="请输入内容"
		    v-model="txt">
		  </el-input>
		  
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="txtShow=false" size="small" >取 消</el-button>
		    <el-button @click="setTxt()" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="选择已发布视频 "
		  :visible.sync="videoShow"
		  width="862px"
		  top="15vh">
		  <div style="height: 500px;overflow-y: scroll;display: flex;flex-wrap: wrap;justify-content: space-between;box-sizing: border-box;padding: 0 30px;">
			  <div v-for="(item,index) in videoList" :key="index" style="width: 366px;height: 209px;border-radius: 4px;margin-bottom: 20px;position: relative;">
				  <video width="366" height="209" style="border-radius: 4px;" :src="item.act_desc[1].content" controls="true" :autoplay="false" ></video>
				  <img @click="item.checked = false" v-if="item.checked" style="width: 18px;height: 18px;position: absolute;right: 16px;top: 16px;cursor: pointer;" src="../../assets/Home/xuanzhong.png"/>
				  <img @click="item.checked = true" v-else style="width: 18px;height: 18px;position: absolute;right: 16px;top: 16px;cursor: pointer;" src="../../assets/Home/moren.png"/>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="setvideoList()" size="small" >清 空</el-button>
		    <el-button @click="videoShow=false" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="选择已发布动态"
		  :visible.sync="articleShow"
		  width="862px"
		  top="15vh">
		  <div style="height: 500px;overflow-y: scroll;display: flex;flex-wrap: wrap;justify-content: space-between;box-sizing: border-box;padding: 0 30px;">
			  <div v-for="(item,index) in articleList" :key="index" class="d-flex a-center"
			  style="width: 366px;height: 80px;background: #F6F6F6;border-radius: 4px;position: relative;padding: 0 16px;box-sizing: border-box;">
				  <img @click="item.checked = false" v-if="item.checked" style="width: 18px;height: 18px;position: absolute;right: 16px;top: 16px;cursor: pointer;" src="../../assets/Home/xuanzhong.png"/>
				  <img @click="item.checked = true" v-else style="width: 18px;height: 18px;position: absolute;right: 16px;top: 16px;cursor: pointer;" src="../../assets/Home/moren.png"/>
				  <div>
					  <div style="font-size: 14px;font-weight: 600;">{{item.title}}</div>
					  <div class="thd2" style="font-size: 12px;color: #888888;margin-top: 14px;">{{getTxt(item.doc_content)}}</div>
				  </div>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="setarticleList()" size="small" >清 空</el-button>
		    <el-button @click="articleShow=false" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="选择资料"
		  :visible.sync="fileShow"
		  width="550px"
		  center
		  :show-close="false"
		  top="15vh">
			<div class="d-flex a-center j-center">
				<div style="width: 420px;display: flex;flex-wrap: wrap;overflow-y: scroll;max-height: 300px;">
					<div style="width: 100%;padding: 12px;box-sizing: border-box;position: relative;margin-bottom: 30px;"
					class="" v-for="(item,index) in fileList">
						<div class="d-flex a-center">
							<div style="width: 50px;">
								<img @click="item.checked = false" v-if="item.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/Home/xuanzhong.png"/>
								<img @click="item.checked = true" v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/Home/moren.png"/>
							</div>
							
							<div class="d-flex flex-1">
								<div class="text-center">
									<img style="width: 50px;height: 50px;" src="../../assets/itemStore/wendang.png" />
								</div>
								<div class="d-flex a-center">
									<div style="font-size: 12px;margin-left: 6px;width: 200px;"
									class="thd2">
										{{item.name}}
									</div>
								</div>
								<div @click="setopen(item,index)" class="d-flex a-center" style="font-size: 12px;color: #000000;margin-left: auto;cursor: pointer;">
									展开文件夹
									<img v-if="item.isopen" style="width: 12px;height: 12px;" src='../../assets/itemStore/shangla.png' />
									<img v-else style="width: 12px;height: 12px;" src='../../assets/itemStore/xiala.png' />
								</div>
							</div>
						</div>
						<div v-if="item.isopen" style="display: flex;flex-wrap: wrap;justify-content: space-between;" class="wd">
							<div  style="width: 33%;box-sizing: border-box;position: relative;display: flex;flex-wrap: wrap;margin-top: 10px;"
							 v-for="(val,key) in item.child" :key="key">
								<div class="d-flex a-center w-100">
									<div style="width: 50px;">
										<img @click="val.checked = false" v-if="val.checked" style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/Home/xuanzhong.png"/>
										<img @click="val.checked = true" v-else style="width: 18px;height: 18px;cursor: pointer;" src="../../assets/Home/moren.png"/>
									</div>
									
									<div class="w-100">
										<div class="text-center">
											<img style="width: 40px;height: 50px;" src="../../assets/itemStore/wdnang.png" />
										</div>
										<div style="font-size: 12px;color: #888888;"
										class="thd2 text-center">
											{{val.real_name}}
										</div>
									</div>
								</div>
								
							</div>
						</div>
						
					</div>
				</div>
			</div>
			  
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="setfileList()" size="small" >清 空</el-button>
		    <el-button @click="fileShow=false" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
		<el-dialog
		  title="选择合作伙伴"
		  :visible.sync="hzhbShow"
		  width="862px"
		  center
		  :show-close="false"
		  top="15vh">
		  <div style="max-height: 500px;overflow-y: scroll;display: flex;flex-wrap: wrap;
		  justify-content: space-between;box-sizing: border-box;padding: 0 30px;">
			  <div v-for="(item,index) in myptlist" :key="index" class="d-flex a-center" 
			  style="width: 366px;height: 80px;background: #F6F6F6;border-radius: 4px;
			  position: relative;padding: 0 16px;box-sizing: border-box;margin-bottom: 16px;">
				  <img @click="item.checked = false" v-if="item.checked" style="width: 18px;height: 18px;position: absolute;right: 16px;top: 16px;cursor: pointer;" src="../../assets/Home/xuanzhong.png"/>
				  <img @click="item.checked = true" v-else style="width: 18px;height: 18px;position: absolute;right: 16px;top: 16px;cursor: pointer;" src="../../assets/Home/moren.png"/>
				  <div style="height: 60px;display: flex;">
					  <div style="width: 60px;height: 60px;">
						  <img style="width: 60px;height: 60px;" :src="item.logo_thumb" />
					  </div>
					  <div style="height: 60px;margin-left: 20px;flex: 1;display: flex;flex-direction: column;justify-content: space-between;">
						  <div style="font-size: 14px;font-weight: 600;">{{item.company_name}}</div>
						  <div style="font-size: 12px;color: #666666;">{{item.kf_tel}}</div>
						  <div class="thd2" style="font-size: 12px;color: #666666;">{{item.business_address}}</div>
					  </div>
				  </div>
			  </div>
		  </div>
		  <span slot="footer" class="dialog-footer d-flex j-center">
		    <el-button @click="setmyptList()" size="small" >清 空</el-button>
		    <el-button @click="hzhbShow=false" size="small" type="primary" >确 定</el-button>
		  </span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				token:localStorage.getItem('token'),
				user_id:localStorage.getItem('user_id'),
				goodsPrice : '',
				goodsmsg : {
					cat_str : '',
					goods_img : '', //产品主图
					goods_name : '', //产品名称
					goods_gallery : [ //轮播图
						// {img :''},
						// {img :''},
						// {img :''},
						// {img :''},
					],
					product_img : '',  //产品规格图
					goods_video :'',  //视频
					desc_mobile : [] //产品详情图
				},
				goodsImgbase64 : '', //产品主图base64
				descMobilebase64 : [], //产品详情图base64
				productImgbase64 : '', //产品规格图base64
				goodsGallerybase64 : [], //轮播图base集合
				descIndex : 0,
				shopoptions : [],
				cat_id : '', //产品分类id
				user_cat : '', //店铺分类id
				imgs: [
					{
						is_main: true,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					},{
						is_main: false,
						flag: '',
						is_show: '',
						percenTage: '',
						url: ''
					}
				],
				selected: '',
				videoFlag: false,
				//是否显示进度条
				videoUploadPercent: "",
				//进度条的进度，
				isShowUploadVideo: false,
				//显示上传按钮
				video_url: '',
				dialogImageUrl: '',
				dialogVisible: false,
				title: '',
				options: [],
				shop_classify: '',
				color_classify: [],
				custom_color: '',
				custom_specification: '',
				size: [],
				unify_price: 2000,
				unify_stock: 2000,
				percenTage :0,
				imgflag :false,
				catName : '',
				goods_attr : [],
				goods_type : '',
				attrarr : [],
				attrarr1 :[],
				norms : [],
				tableHead : [
					{name : '规格1'},
					{name : '规格2'},
					{name : '价格'},
					{name : '库存'},
				],
				attrImg : '',
				goods_attr_id_img : [],
				goods_product_info : [],
				imgInd : false,
				imgName :[],
				imgUrl : [],
				rgbaState :false,
				minNumber : '',
				maxNumber : '',
				currentPage: 1, //初始页
				showStatus : false,
				pageSize : 10,
				goodsId : [],
				txt:'',
				total_records : 0,
				optionalcur : '',
				optionMsg : [],
				allseloptionStatus : 0,
				goods_optional_ids : [],
				dialogTableVisible:false,
				txtShow:false,
				shopData:[],
				videoBase64 : '',
				qyjs:false,
				dyList:[],
				imgindex:'',
				dyIndex:'',
				txt:'',
				txtShow:false,
				videoShow:false,
				articleShow:false,
				videoList:[],
				articleList:[],
				hide_status:0,
				fileShow:false,
				fileList:[],
				hzhbShow:false,
				myptlist:[],
				ac_title:'应用客户'
			}
		},
		methods: {
			setopen(item,index){
				
				if(item.password != ''){
					this.$message({
						showClose: true,
						message: '文件已设定密码不可单独设定文件',
						type: 'error',
						offset: 350
					})
					return
				}
				if(item.child.length != 0){
					item.isopen = !item.isopen
					return
				}
				let param = {
					act : 'get_enterprise_file_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					cata_id: item.id
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						res.data.forEach((val)=>{
							item.child.push({...val,checked:false})
						})
						item.isopen = !item.isopen
					} 
				})
			},
			getTxt(item){
				if(typeof item  == 'string'){
					return
				}
				let status = true
				let str = ''
				item.forEach((item)=>{
					if(status && item.type == 1){
						status = false
						str = item.content
					}
				})
				return str
			},
			setmyptList(){
				this.myptlist.forEach((item)=>{
					item.checked = false
				})
			},
			setfileList(){
				this.fileList.forEach((item)=>{
					item.checked = false
					item.child.forEach((val=>{
						val.checked = false
					}))
				})
			},
			setarticleList(){
				this.articleList.forEach((item)=>{
					item.checked = false
				})
			},
			setvideoList(){
				this.videoList.forEach((item)=>{
					item.checked = false
				})
			},
			my_partnerse_list(){
				let param = {
					act : 'my_partnerse_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					business_id: localStorage.getItem('ru_id')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						res.data.forEach((item)=>{
							this.myptlist.push({...item,checked:false})
						})
					} 
				})
			},
			file_cata_list(){
				let param = {
					act : 'file_cata_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					business_id: localStorage.getItem('ru_id')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						res.data.forEach((item)=>{
							this.fileList.push({...item,checked:false,isopen:false,child:[]})
						})
					} 
				})
			},
			// 获取产品分类
			get_enterprise_dynamic_list(){
				let param = {
					act : 'get_enterprise_dynamic_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					size: 99,
					business_id: localStorage.getItem('ru_id')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						res.data.forEach((item)=>{
							if(item.doc_type == 1){
								this.videoList.push({...item,checked:false})
							}else{
								this.articleList.push({...item,checked:false})
								
							}
						})
					} 
				})
			},
			closeBox(){
				this.qyjs = false
			},
			setcenter(){
				if(this.dyList[this.dyIndex].type == 1){
					this.dyList[this.dyIndex].type = 3
				}else if(this.dyList[this.dyIndex].type == 3){
					this.dyList[this.dyIndex].type = 1
				}
			},
			setTxt(){
				this.dyList.push({type:1,content:this.txt})
				this.txt = ''
				this.txtShow = false
			},
			getLiveDylist(file, fileList) {
				this.dyList.push({type:2,content:file.data})
			  //   this.getBase64(file.raw).then((res) => {
					// this.dyList.push({type:2,content:res})
					// let params = {
					// 	act:'upload_photo_introduction',
					// 	token: localStorage.getItem('token'),
					// 	user_id: localStorage.getItem('user_id'),
					// 	file:res
					// }
					// this.$api.upload_photo_introduction(params).then((data)=>{
					// 	if(res.code == 0){
					// 		this.dyList.push({type:2,content:data.data})
					// 	}
					// })
			  //   })
			},
			//上移简介图片
			upFiles(){
				if(this.dyIndex === 0||this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex-1,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex+1,1)
				this.dyIndex--
			},
			//下移简介图片
			dowFiles(){
				if(this.dyIndex === (this.dyList.length-1) || this.dyIndex === ''){
					return
				}
				this.dyList.splice(this.dyIndex+2,0,this.dyList[this.dyIndex])
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex++
			},
			//删除简介图片
			delfiles(){
				if(!this.dyList.length){
					return
				}
				this.dyList.splice(this.dyIndex,1)
				this.dyIndex = ''
			},
			videoSuccess(response, file, fileList){
				this.videoBase64 = response.data
			},
			handleSelectionChange(val) {
				let goodsId = []
				let optmsg = []
				val.forEach((item) => {
					goodsId.push(item.id)
					optmsg.push(item)
				})
				this.optionMsg = optmsg
				this.goods_ids = goodsId
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getOnsalegoods()()
			},
			selectOptional(ite,ind){
				this.allseloptionStatus = 0
				this.optionalcur = ind
				this.dialogTableVisible = true
			},		
			allselectoptional(){
				this.allseloptionStatus = 1
				this.dialogTableVisible = true
			},
			confirmOptional(){
				if(this.allseloptionStatus == 0){
					this.goods_optional_ids = []
					this.norms[this.optionalcur].goods_optional_ids = this.goods_ids.join('|')
					this.norms[this.optionalcur].goods_optional_products = this.optionMsg
				}else if(this.allseloptionStatus == 1){
					this.goods_optional_ids = this.goods_ids
					this.norms.forEach((v) => {
						v.goods_optional_ids =  this.goods_ids.join('|')
						v.goods_optional_products = this.optionMsg
					})
				}
				this.dialogTableVisible = false
			},
			togRgbaState(){
				let productAttr = []
				this.norms.forEach((v) => {
					productAttr.push({product_id:v.product_id,goods_attr_id:v.goods_attr_id,product_price:v.product_price,product_number:v.product_number})
				})
				this.goods_product_info = productAttr
				if(this.goodsmsg.desc_mobile.length == 0){
					this.$message({
						showClose: true,
						message: '请上传产品详情图',
						type: 'error',
						offset: 350
					})
				}else if(this.goodsmsg.goods_name == ''){
					this.$message({
						showClose: true,
						message: '请填写产品名称',
						type: 'error',
						offset: 350
					})
				}else {
					this.rgbaState = !this.rgbaState
					let numberArr = []
					this.goods_product_info.forEach(v=>{
						numberArr.push(v.product_price)
					})
					this.minNumber = Math.min(...numberArr).toFixed(2)
					this.maxNumber = Math.max(...numberArr).toFixed(2)
				}
			},
			togleState(){
				this.rgbaState = !this.rgbaState
			},
			setPrice(e){
				this.norms.forEach((item)=>{
					item.product_price = e.target.value
				})
			},
			// 获取产品分类
			getGoodscategory(){
				let param = {
					act : 'get_goods_category',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id')
				}
				this.$api.login(param).then((res)=>{
					if(res.code == 0){
						let json = JSON.parse(JSON.stringify(res.data).replace(/cat_name/g,"label"))
						let json1 = JSON.parse(JSON.stringify(json).replace(/cat_id/g,"value"))
						this.options = json1
					} 
				})
			},
			// 获取图片转base64
			getBase64(file) {
				return new Promise(function(resolve, reject) {
					const reader = new FileReader()
					let imgResult = ''
					reader.readAsDataURL(file)
					reader.onload = function() {
						imgResult = reader.result
					}
					reader.onerror = function(error) {
						reject(error)
					}
					reader.onloadend = function() {
						resolve(imgResult)
					}
				})
			},
			// 图片转base64
			getFile(file, fileList) {
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						this.strimagebase64 = res
						// this.handleUploadFile()
						let param = {
							act: 'public_upload_file',
							file: this.strimagebase64
						}
						this.$api.uploadPicture(param).then((res) => {
							if (res.code == 0) {
								this.attrImg = res.data
								this.$message({
									showClose: true,
									message: '图片上传成功',
									type: 'cuccess',
									offset: 350
								})
							} else {
								this.$message({
									showClose: true,
									message: '图片上传失败',
									type: 'error',
									offset: 350
								})
							}
						}).catch(response => {
							this.$message({
								showClose: true,
								message: '图片上传失败',
								type: 'error',
								offset: 350
							})
						})
					}
				})
			},
			beforeUpload(file,ite){
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message({
						showClose: true,
						message: '上传头像图片大小不能超过 2MB!',
						type: 'error',
						offset: 350
					})
				}
				return isLt2M;
			},
			// 产品主图
			getGoodsimg(file,fileList){
				this.getBase64(file.raw).then(res => {
					this.goodsImgbase64 = res
				})
			},
			// 详情图
			getDescmobile(file,fileList){
				this.getBase64(file.raw).then(res => {
					let params = res.split(',')
					if (params.length > 0) {
						let param = {
							act: 'upload_desc_pic',
							token: localStorage.getItem('token'),
							user_id: localStorage.getItem('user_id'),
							file: res
						}
						this.$api.login(param).then((res) => {
							if (res.code == 0) {
								this.goodsmsg.desc_mobile.push({img:res.data})
								this.descMobilebase64.push(res.data)
							} else {
								this.$message({
									showClose: true,
									message: '图片上传失败',
									type: 'error',
									offset: 350
								})
							}
						}).catch(response => {
							this.$message({
								showClose: true,
								message: '图片上传失败',
								type: 'error',
								offset: 350
							})
						})
					}
				})
			},
			descimgCli(index){
				this.descIndex = index
			},
			// 产品详情处理，上移，下移，删除
			swapArray(arr, index1, index2) {
			    arr[index1] = arr.splice(index2, 1, arr[index1])[0];
			    return arr;
			},
			moveup(){
				this.swapArray(this.goodsmsg.desc_mobile, this.descIndex, this.descIndex - 1);
				this.swapArray(this.descMobilebase64, this.descIndex, this.descIndex - 1);
			},
			movedown(){
				this.swapArray(this.goodsmsg.desc_mobile, this.descIndex, this.descIndex + 1);
				this.swapArray(this.descMobilebase64, this.descIndex, this.descIndex - 1);
			},
			delDescimg(){
				this.goodsmsg.desc_mobile.splice(this.descIndex,1)
				this.descMobilebase64.splice(this.descIndex,1)
			},
			handleUploadFile(){},
			// 产品分类id
			handleCascaderChange(value) {
				this.cat_id = value[2]
				console.log(this.cat_id);
				let selected = this.$refs.item_classify.getCheckedNodes()
				this.catName = selected[0].label
				this.goodsmsg.cat_str = selected[0]['pathLabels'].toString().replace(/,/g, '——')
				this.norms = []
				this.attrarr = []
				this.attrarr1 = []
				// this.getCategoryToAttr()
			},
			getFileType(name) {
				let startIndex = name.lastIndexOf(".")
				if (startIndex !== -1) {
					return name.slice(startIndex + 1).toLowerCase()
				} else {
					return ""
				}
			},
			beforeAvatarUpload(file,fileList){
				let suffix = this.getFileType(file.name) //获取文件后缀名
				let suffixArray = ["jpg", "png", "jpeg", "gif"] //限制的文件类型，根据情况自己定义
				if (suffixArray.indexOf(suffix) === -1) {
					this.$message({
						showClose: true,
						message: '文件格式错误',
						type: 'error',
						offset: 350,
						duration: 2000
					})
				}
				return suffixArray
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url
				this.dialogVisible = true
			},
			handlePictureCardSuccess(response, file, fileList) {
				this.video_url = fileList[0].url
			},
			//上传前回调
			beforeUploadVideo(file) {
				var fileSize = file.size / 1024 / 1024 < 50;
				if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) ==
					-1) {
					this.$message({
						showClose: true,
						message: '请上传正确格式',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return false
				}
				if (!fileSize) {
					this.$message({
						showClose: true,
						message: '视频大小不能大于50M',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return false;
				}
				this.isShowUploadVideo = false
			},
			//进度条
			uploadVideoProcess(event, file, fileList) {
				this.videoFlag = true;
				this.videoUploadPercent = file.percentage.toFixed(0) * 1;
			},
			uploadPicProcess(event, file, fileList, index) {
				this.imgflag = true;
				this.percenTage = file.percentage.toFixed(0) * 1;
			},
			//上传成功回调
			handleVideoSuccess(res, file) {
				this.isShowUploadVideo = true;
				this.videoFlag = false;
				this.videoUploadPercent = 0;

				// 前台上传地址
				console.log(file)
				if (file.status == 'success') {
					this.video_url = file.url;
					console.log(file)
				} else {
					this.$message({
						showClose: true,
						message: '上传失败，请重新上传',
						type: 'error',
						offset: 350,
						duration: 2000
					})
				}
			},
			delete_color(index) {
				this.color_classify.splice(index, 1)
			},
			add_specification() {
				this.size.push(this.custom_specification)
			},
			publishGoods(){
				// if(!this.cat_id){
				// 	this.$message.warning('请选择产品类别')
				// 	return
				// }
				if(!this.goodsImgbase64){
					this.$message({
						showClose: true,
						message: '请上传产品主图',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return
				}
				if(!this.goodsmsg.goods_name){
					this.$message({
						showClose: true,
						message: '产品名称不能为空',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return
				}
				if(!this.descMobilebase64){
					this.$message({
						showClose: true,
						message: '请上传产品详情图片',
						type: 'error',
						offset: 350,
						duration: 2000
					})
					return
				}
				// if(this.goodsPrice == ''){
				// 	this.$message.warning('产品价格不能为空')
				// 	return
				// }
				// if(this.goodsPrice == 0){
				// 	this.$message.warning('产品定价不能为0')
				// 	return
				// }
				let video_ids = []
				this.videoList.forEach((item)=>{
					if(item.checked){
						video_ids.push(item.id)
					}
				})
				let doc_ids = []
				this.articleList.forEach((item)=>{
					if(item.checked){
						doc_ids.push(item.id)
					}
				})
				let file_cata_ids = []
				let file_ids = []
				this.fileList.forEach((item)=>{
					if(item.checked){
						file_cata_ids.push(item.id)
					}
					item.child.forEach((val)=>{
						if(val.checked){
							file_ids.push(val.id)
						}
					})
				})
				let s_p_ids = []
				this.myptlist.forEach((item)=>{
					if(item.checked){
						s_p_ids.push(item.id)
					}
				})
				let param = {
					act : 'enterprise_goods_add',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					cat_id : this.cat_id,
					goods_name : this.goodsmsg.goods_name,
					goods_img : this.goodsImgbase64,
					desc_mobile : this.dyList,
					goods_video : this.videoBase64,
					shop_price : this.goodsPrice,
					video_ids:video_ids.join(','),
					doc_ids:doc_ids.join(','),
					s_p_ids:s_p_ids.join(','),
					file_cata_ids:file_cata_ids.join(','),
					file_ids:file_ids.join(','),
					hide_status:this.hide_status,
					ac_title:this.ac_title
				}
				const loading = this.$loading({
					lock: true,
					text: '发布中',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				this.$api.login(param).then((res) => {
					loading.close()
					if(res.code == 0){
						this.$message({
							showClose: true,
							message: '添加产品成功',
							type: 'success',
							offset: 350,
							duration: 2000
						})
					}else {
						this.$message({
							showClose: true,
							message: res.msg,
							type: 'error',
							offset: 350,
							duration: 2000
						})
					}
				})
			},
			autoFill(list, column) {
				let length = list.length;
				let temp = JSON.parse(JSON.stringify(list))
				let empty
				if (list == this.color_classify) {
					empty = (length + 1) % column
				} else {
					empty = length % column
				}

				if (empty !== 0) {
					for (let i = 0; i < (column - empty); i++) {
						temp.push('')
					}
				}
				console.log(temp)
				return temp;
			},
			arraySpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex % 2 === 0) {
					if (columnIndex === 0) {
						return [1, 2];
					} else if (columnIndex === 1) {
						return [0, 0];
					}
				}
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex % 2 === 0) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			}
		},
		mounted() {
			this.getGoodscategory()
			this.get_enterprise_dynamic_list()
			this.file_cata_list()
			this.my_partnerse_list()
		}
	}
</script>

<style lang="scss">
	.hzhb::after{
		content: '';
		width: 116px;
	}
	.thd2 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
	.thd3 {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.tct{
		text-align: center;
		text-indent: 0px;
	}
	.ntxt{
		text-align: left;
		text-indent: 30px;
	}
	.el-cascader-menu {
		width: 33.3%;
	}

	.el-cascader-node {
		padding: 0 2rem 0 1rem !important;
	}

	.el-cascader {
		.el-input__inner {
			font-size: 0.75rem;
		}
	}

	.in-active-path {
		color: #1E69FF !important;
		background: #EEF4FF !important;

		&::before {
			content: '';
			width: 0.13rem;
			height: 1.25rem;
			background: #1E69FF;
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
		}
	}

	.is-active {
		color: #1E69FF !important;
		background: #EEF4FF !important;
	}

	.el-scrollbar__wrap {
		overflow: auto !important;
		margin-right: -6px !important;
	}

	.el-scrollbar__view,
	.el-cascader-menu__list {
		padding: 0 !important;
	}




	.avatar-uploader {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.el-upload--text {
		width: 100%;
		height: 100%;
	}

	.avatar-uploader:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100%;
		height: 100%;
		line-height: 100%;
		text-align: center;
	}

	.avatar {
		width: 7.5rem;
		height: 7.5rem;
		display: block;
	}

	.el-upload-list--picture {
		position: absolute;
		left: 0;
		top: 3.13rem;
		width: 100% !important;

		.el-upload-list__item,
		.is-success {
			width: 100% !important;
			height: 100% !important;
		}
	}

	.el-progress,
	.el-progress--circle,
	.el-progress-circle {
		width: 100% !important;
		height: 100% !important;
	}
</style>
<style lang="scss" scoped>
	.wd::after{
		content: '';
		width: 33%;
	}
	::-webkit-scrollbar {
	  display: none; /* Chrome Safari */
	}
	.text-suojin{
		 overflow: hidden;
		 text-overflow: ellipsis;
		 display: -webkit-box; 
		 -webkit-line-clamp: 2;
		 -webkit-box-orient: vertical;
	}
	.tableHead div:first-child{
		border-left: 2px solid #BBBBBB;
	}
	.tableBody div{
		border-top: 0px solid #BBBBBB !important;
	}
	input[type="checkbox"] {
		width: 1.13rem;
		height: 1.13rem;
		-webkit-appearance: none;
		border: 1px solid #c9c9c9;
		border-radius: 10px;
		outline: none;
		cursor: pointer;
	}

	input[type=checkbox]:checked {
		background: url("../../assets/itemStore/xuanzhong@2x.png")no-repeat;
		background-size: 100% 100%;
	}

	.publish_item {
		max-width: 73.13rem;
		box-sizing: border-box;
		margin: 1.25rem auto;
		background: #FFFFFF;
		padding: 1.81rem 0 3.63rem 0;

		.title::before {
			content: '';
			background: url(../../assets/itemStore/biaoqian@2x.png) no-repeat;
			background-size: 100%;
			width: 0.94rem;
			height: 1.19rem;
			position: absolute;
			left: -1.3rem;
			top: 50%;
			transform: translate(0, -50%);
		}

		.second_title::before {
			content: '';
			background: url(../../assets/itemStore/xiaobiao@2x.png) no-repeat;
			background-size: 100%;
			width: 0.44rem;
			height: 0.44rem;
			position: absolute;
			left: -1rem;
			top: 50%;
			transform: translate(0, -50%);
		}


		.sale_data {
			position: relative;
			width: 48.44rem;
			margin: 0 auto;

			.selected {}

			.select {
				height: 20rem;
			}
		}

		.base_info {
			width: 48.44rem;
			margin: 0 auto;
			// margin-top: 3rem;
		}

		.sale_property {
			width: 48.44rem;
			margin: 0 auto;
		}

		.buttons {
			width: 48.44rem;
			margin: 0 auto;
			margin-top: 3.88rem;

			.button {
				width: 10.3rem;
				height: 1.8rem;
				border-radius: 0.9rem;
				text-align: center;
				line-height: 1.8rem;
				font-size: 0.75rem;
				border: 2px solid #000000;
				cursor: pointer;
			}
		}
	}
</style>
